// header
const header = document.querySelector('.global-header');

if (header) {
  const toggleBtns = document.querySelectorAll('[data-role="toggle-button"]') as NodeListOf<HTMLElement>;

  toggleBtns.forEach((btn) => {
    btn.addEventListener('click', function (this: HTMLElement) {

      const isOpen = this.classList.contains('is-menu-open');

      // まず他のボタンから is-menu-open を削除
      toggleBtns.forEach((otherBtn) => {
        if (otherBtn !== this) {
          otherBtn.classList.remove('is-menu-open');
          otherBtn.setAttribute('aria-expanded', 'false');
          otherBtn.setAttribute('aria-label', 'メニュー');
        }
      });

      if (isOpen) {
        // クリックされたボタンが開いていたら閉じる
        this.classList.remove('is-menu-open');
        this.setAttribute('aria-expanded', 'false');
        this.setAttribute('aria-label', 'メニュー');

      } else {
        // 閉じていたら開く
        this.classList.add('is-menu-open');
        this.setAttribute('aria-expanded', 'true');
        this.setAttribute('aria-label', '閉じる');
      }
    });
  });
}

// tab
const cmnTabElms: NodeListOf<HTMLElement> = document.querySelectorAll('[data-role="cmn-tab"]');

if (cmnTabElms.length) {
  cmnTabElms.forEach((elm) => {
    const tabBtnsArea = elm.querySelector<HTMLElement>('[role="tablist"]');
    if (!tabBtnsArea) return;

    tabBtnsArea.addEventListener('click', (ev: MouseEvent) => {
      const tabBtnElm = ev.target as HTMLElement | null;
      if (!tabBtnElm) return;

      if (tabBtnElm.hasAttribute('data-target')) {
        const tabCurrentTarget = tabBtnElm.getAttribute('data-target');
        if (!tabCurrentTarget) return;

        // ボタン切り替え
        const tabBtns = elm.querySelectorAll<HTMLElement>('[data-role="tabbtn"]');
        tabBtns.forEach((tabBtn) => {
          const tabTarget = tabBtn.getAttribute('data-target');
          if (tabTarget === tabCurrentTarget) {
            tabBtn.classList.add('is-active');
            tabBtn.setAttribute('aria-selected', 'true');
            tabBtn.removeAttribute('tabindex');
          } else {
            tabBtn.classList.remove('is-active');
            tabBtn.setAttribute('aria-selected', 'false');
            tabBtn.setAttribute('tabindex', '-1');
          }
        });

        // パネル切り替え
        const tabContentsElm = elm.querySelectorAll<HTMLElement>('[role="tabpanel"]');
        tabContentsElm.forEach((tabContents) => {
          const tabTarget = tabContents.getAttribute('id');
          if (tabTarget === tabCurrentTarget) {
            tabContents.classList.add('is-active');
          } else {
            tabContents.classList.remove('is-active');
          }
        });
      }
    });
  });
}

// 目次
const indexBtn = document.querySelector('[data-role="index-button"]') as HTMLElement | null;

if (indexBtn !== null) {
  const indexWrap = indexBtn.closest('[data-role="index-contents"]') as HTMLElement | null;
  const indexList = indexWrap?.querySelector('[data-role="index-list"]') as HTMLElement | null;

  indexBtn.addEventListener('click', (event: Event) => {
    const target = event.currentTarget as HTMLElement;

    // ボタンを非表示にする
    target.classList.add('hidden');

    // indexList のクラスを切り替え
    if (indexList) {
      indexList.classList.remove('max-h-[7lh]');
      indexList.classList.add('max-h-max');
    }
  });
}
